"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateTeamMemberProfileRequestSchema = exports.updateTeamMemberCapabilitiesRequestSchema = exports.updateTeamWorkingHoursRequestSchema = exports.updateTeamMemberStatusRequestSchema = exports.updateTeamMemberRoleRequestSchema = exports.acceptTeamInvitationResponseSchema = exports.teamInvitationPreviewSchema = exports.createTeamInvitationResponseSchema = exports.teamInvitationSummarySchema = exports.teamInvitationStatusSchema = exports.teamInvitationTokenSchema = exports.inviteTeamMemberRequestSchema = exports.teamMemberIdSchema = exports.teamManagementListResponseSchema = exports.teamManagementMemberSchema = exports.weeklyWorkingHoursSchema = exports.teamWorkingHoursDaySchema = exports.teamMemberListResponseSchema = exports.scheduledTeamMemberSchema = exports.teamMemberSchema = exports.teamMemberTagsSchema = exports.teamMemberTagSchema = exports.teamMemberCalendarColorSchema = exports.DEFAULT_TEAM_MEMBER_CALENDAR_COLOR = exports.TEAM_MEMBER_CALENDAR_COLORS = exports.manageableTeamRoleSchema = exports.teamWeekdaySchema = exports.membershipStatusSchema = void 0;
const zod_1 = require("zod");
const business_1 = require("./business");
const staff_capability_1 = require("./staff-capability");
const user_profile_1 = require("./user-profile");
exports.membershipStatusSchema = zod_1.z.enum(["INVITED", "ACTIVE", "INACTIVE"]);
exports.teamWeekdaySchema = zod_1.z.enum([
    "MONDAY",
    "TUESDAY",
    "WEDNESDAY",
    "THURSDAY",
    "FRIDAY",
    "SATURDAY",
    "SUNDAY",
]);
exports.manageableTeamRoleSchema = zod_1.z.enum([
    "ADMIN",
    "DISPATCHER",
    "TECHNICIAN",
]);
exports.TEAM_MEMBER_CALENDAR_COLORS = [
    "#C2410C",
    "#EA580C",
    "#0F766E",
    "#0D9488",
    "#1976D2",
    "#27348B",
    "#4E342E",
    "#B91C1C",
    "#DC2626",
    "#166534",
    "#2E7D32",
    "#0284C7",
    "#8E24AA",
    "#6D4C41",
    "#9D174D",
    "#DB2777",
    "#3F7D20",
    "#1E5AA8",
    "#5B21B6",
    "#6D38C5",
    "#263238",
    "#C45100",
    "#00695C",
    "#0E9FB1",
    "#0B65A6",
    "#3921A4",
    "#4658B8",
    "#817200",
];
exports.DEFAULT_TEAM_MEMBER_CALENDAR_COLOR = "#0E9FB1";
exports.teamMemberCalendarColorSchema = zod_1.z.enum(exports.TEAM_MEMBER_CALENDAR_COLORS);
exports.teamMemberTagSchema = zod_1.z.string().trim().min(1).max(32);
exports.teamMemberTagsSchema = zod_1.z
    .array(exports.teamMemberTagSchema)
    .max(20)
    .superRefine((items, context) => {
    const normalized = items.map((item) => item.toLocaleLowerCase("en-US"));
    if (new Set(normalized).size !== items.length) {
        context.addIssue({
            code: "custom",
            message: "Team member tags must be unique.",
        });
    }
});
exports.teamMemberSchema = zod_1.z.object({
    membershipId: zod_1.z.string().uuid(),
    userId: zod_1.z.string().uuid(),
    firstName: zod_1.z.string().nullable().optional(),
    lastName: zod_1.z.string().nullable().optional(),
    mobilePhone: zod_1.z.string().nullable().optional(),
    displayName: zod_1.z.string().nullable(),
    email: zod_1.z.string().email().nullable(),
    role: business_1.membershipRoleSchema,
});
exports.scheduledTeamMemberSchema = exports.teamMemberSchema.extend({
    calendarColor: exports.teamMemberCalendarColorSchema,
    tags: exports.teamMemberTagsSchema,
});
exports.teamMemberListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.teamMemberSchema),
});
exports.teamWorkingHoursDaySchema = zod_1.z
    .object({
    weekday: exports.teamWeekdaySchema,
    isWorking: zod_1.z.boolean(),
    startMinute: zod_1.z.number().int().min(0).max(1439).nullable(),
    endMinute: zod_1.z.number().int().min(1).max(1440).nullable(),
})
    .superRefine((value, context) => {
    if (!value.isWorking) {
        if (value.startMinute !== null || value.endMinute !== null) {
            context.addIssue({
                code: "custom",
                message: "Non-working days cannot have working hours.",
            });
        }
        return;
    }
    if (value.startMinute === null ||
        value.endMinute === null ||
        value.startMinute >= value.endMinute) {
        context.addIssue({
            code: "custom",
            message: "Working days require a valid start and end time.",
        });
    }
});
exports.weeklyWorkingHoursSchema = zod_1.z
    .array(exports.teamWorkingHoursDaySchema)
    .length(7)
    .superRefine((days, context) => {
    const weekdays = new Set(days.map((day) => day.weekday));
    if (weekdays.size !== 7) {
        context.addIssue({
            code: "custom",
            message: "Working hours must include each weekday once.",
        });
    }
});
exports.teamManagementMemberSchema = exports.scheduledTeamMemberSchema.extend({
    firstName: zod_1.z.string().nullable(),
    lastName: zod_1.z.string().nullable(),
    mobilePhone: zod_1.z.string().nullable(),
    status: exports.membershipStatusSchema,
    isPrimaryOwner: zod_1.z.boolean(),
    workingHours: exports.weeklyWorkingHoursSchema,
    invitedAt: zod_1.z.iso.datetime().nullable(),
    activatedAt: zod_1.z.iso.datetime().nullable(),
    deactivatedAt: zod_1.z.iso.datetime().nullable(),
    createdAt: zod_1.z.iso.datetime(),
    updatedAt: zod_1.z.iso.datetime(),
    capabilities: zod_1.z.array(staff_capability_1.staffCapabilitySchema),
    capabilityOverrides: zod_1.z.array(staff_capability_1.staffCapabilityOverrideSchema),
});
exports.teamManagementListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.teamManagementMemberSchema),
});
exports.teamMemberIdSchema = zod_1.z.string().uuid();
exports.inviteTeamMemberRequestSchema = user_profile_1.userProfileInputSchema.extend({
    email: zod_1.z.string().trim().toLowerCase().pipe(zod_1.z.string().email().max(320)),
    role: exports.manageableTeamRoleSchema,
    calendarColor: exports.teamMemberCalendarColorSchema.default(exports.DEFAULT_TEAM_MEMBER_CALENDAR_COLOR),
    tags: exports.teamMemberTagsSchema.default([]),
});
exports.teamInvitationTokenSchema = zod_1.z
    .string()
    .regex(/^[A-Za-z0-9_-]{43}$/, "Invitation token is invalid.");
exports.teamInvitationStatusSchema = zod_1.z.enum([
    "PENDING",
    "ACCEPTED",
    "EXPIRED",
    "REVOKED",
]);
exports.teamInvitationSummarySchema = zod_1.z.object({
    invitationId: zod_1.z.string().uuid(),
    acceptancePath: zod_1.z.string().startsWith("/invite/"),
    expiresAt: zod_1.z.iso.datetime(),
});
exports.createTeamInvitationResponseSchema = zod_1.z.object({
    member: exports.teamManagementMemberSchema,
    invitation: exports.teamInvitationSummarySchema,
});
exports.teamInvitationPreviewSchema = zod_1.z.object({
    invitationId: zod_1.z.string().uuid(),
    businessName: zod_1.z.string().min(1).max(120),
    firstName: zod_1.z.string().min(1).max(60).nullable(),
    lastName: zod_1.z.string().min(1).max(59).nullable(),
    mobilePhone: zod_1.z.string().nullable(),
    displayName: zod_1.z.string().min(1).max(120),
    email: zod_1.z.string().email(),
    role: exports.manageableTeamRoleSchema,
    expiresAt: zod_1.z.iso.datetime(),
    status: exports.teamInvitationStatusSchema,
});
exports.acceptTeamInvitationResponseSchema = zod_1.z.object({
    tenantId: zod_1.z.string().uuid(),
    member: exports.teamManagementMemberSchema,
});
exports.updateTeamMemberRoleRequestSchema = zod_1.z.object({
    role: exports.manageableTeamRoleSchema,
});
exports.updateTeamMemberStatusRequestSchema = zod_1.z.object({
    status: zod_1.z.enum(["ACTIVE", "INACTIVE"]),
});
exports.updateTeamWorkingHoursRequestSchema = zod_1.z.object({
    workingHours: exports.weeklyWorkingHoursSchema,
});
exports.updateTeamMemberCapabilitiesRequestSchema = zod_1.z.object({
    capabilities: zod_1.z.array(staff_capability_1.staffCapabilitySchema).superRefine((items, context) => {
        if (new Set(items).size !== items.length) {
            context.addIssue({
                code: "custom",
                message: "Capabilities must be unique.",
            });
        }
    }),
});
exports.updateTeamMemberProfileRequestSchema = user_profile_1.userProfileInputSchema.extend({
    calendarColor: exports.teamMemberCalendarColorSchema,
    tags: exports.teamMemberTagsSchema,
});
//# sourceMappingURL=team.js.map